import { render, staticRenderFns } from "./DetailCreateModal.vue?vue&type=template&id=4cec98e9&scoped=true"
import script from "./DetailCreateModal.vue?vue&type=script&lang=js"
export * from "./DetailCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec98e9",
  null
  
)

export default component.exports